//@ts-nocheck
const mode = import.meta.env.MODE
const env = import.meta.env

//Global object for mapping global settings
const globalConfig = {
  axios: {
    apiUrl: `${env.VITE_API_URL}/API/v2`,
    requestTimeout: env.VITE_REQUEST_TIMEOUT
  },
  storage: env.VITE_FILE_STORE,
  dataEntry: {
    markingAutoSaveTime: Number(env?.VITE_DATA_ENTRY_MARKING_AUTOSAVE_TIME || 30000)
  },
  isDevelopment: mode === 'development'
}

export default globalConfig
